import { render, staticRenderFns } from "./DataImportMedia.vue?vue&type=template&id=d622e0fc&scoped=true&"
import script from "./DataImportMedia.vue?vue&type=script&lang=js&"
export * from "./DataImportMedia.vue?vue&type=script&lang=js&"
import style0 from "./DataImportMedia.vue?vue&type=style&index=0&id=d622e0fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d622e0fc",
  null
  
)

export default component.exports